import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { AppState } from '../../store';
import { selectAccountId } from '../../account/store/account.selectors';
import { PaymentMethod } from '../paymentMethod.models';
import { QueryParams } from '../../models/http.models';
import { environment } from '../../../environments/environment';
import { ListParams } from '../../common/helper/query-params-generic-list.helper';

@Injectable({
  providedIn: 'root',
})
export class PaymentMethodsResource {
  private apiRoot: string = `${environment.API_URL}`;

  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
  ) {}

  get(params?: ListParams): Observable<PaymentMethod> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.get<PaymentMethod>(`${this.apiRoot}/${account_id}/api/payment_method`, {
          params: params as QueryParams,
          headers: {
            ignorenotify: 'true',
          },
        }),
      ),
    );
  }

  update(body: Partial<PaymentMethod>, params?: ListParams): Observable<PaymentMethod> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.put<PaymentMethod>(`${this.apiRoot}/${account_id}/api/payment_method`, body, {
          params: params as QueryParams,
        }),
      ),
    );
  }
}
